import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Screen1 from "./screen1";
import OpenEndedQuestion from "./OpenEndedQuestion";
import SimpleConversation from "./SimpleConversation";
import EmailEntry from "./EmailEntry";
import ThankYou from "./ThankYou";
import Language from "./Language";

const Demo = () => {
    const [screen, setScreen] = useState(1)
    const [response, setResponse] = useState({})
    const [language, setLanguage] = useState("EN")

    // Add a function to handle screen changes with scroll reset
    const handleScreenChange = (newScreen) => {
        // Reset scroll position when changing screens
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        
        // Change the screen
        setScreen(newScreen);
    };

    const saveResponse = (resp) => {
        let _response = {...response}
        _response[screen] = resp
        setResponse(_response)      
    }

    // Update the useEffect to ensure global scroll behavior is correct
    useEffect(() => {
        // Only modify these styles once on mount
        const originalBodyStyle = document.body.style.overflow;
        const originalHtmlStyle = document.documentElement.style.overflow;
        const originalBodyHeight = document.body.style.height;
        const originalHtmlHeight = document.documentElement.style.height;
        
        // Set overflow to auto on body and html to ensure proper scrolling
        document.body.style.overflow = 'auto';
        document.documentElement.style.overflow = 'auto';
        document.body.style.height = 'auto';
        document.documentElement.style.height = 'auto';
        
        return () => {
            // Restore original styles when component unmounts
            document.body.style.overflow = originalBodyStyle;
            document.documentElement.style.overflow = originalHtmlStyle;
            document.body.style.height = originalBodyHeight;
            document.documentElement.style.height = originalHtmlHeight;
        };
    }, []); // Empty dependency array ensures this only runs once

    const renderScreen = () => {
        if(screen === 1){
            return <Screen1 setScreen={() => handleScreenChange(2)} language={language}/>
        }

        if(screen === 2){
            return <OpenEndedQuestion 
                    saveResponse={(resp) => saveResponse(resp)} 
                    setScreen={() => handleScreenChange(3)} 
                    language={language}/>
        }

        if(screen === 3){
            return <SimpleConversation 
                    responses={response}
                    saveResponse={(resp) => saveResponse(resp)} 
                    setScreen={() => handleScreenChange(4)} 
                    language={language}/>
        }

        if(screen === 4){
            return <EmailEntry 
                    saveResponse={(resp) => saveResponse(resp)} 
                    setScreen={() => handleScreenChange(5)} 
                    language={language}
                    responses={response}/>
        }

        if(screen === 5){
            return <ThankYou 
                    language={language}
                    responses={response}/>
        }

        // Fallback to intro screen
        return <Screen1 setScreen={() => handleScreenChange(2)} language={language}/>
    }

    return (
        <Container>
            {/* Language selector can be uncommented if needed */}
            {/* <Language language={language} setLanguage={setLanguage} languages={["EN","FR","ES"]}/> */}
           {renderScreen()}
        </Container>
    )
}

export default Demo

const Container = styled.div`
    display: flex;
    justify-content: center;
    font-family: 'Raleway';
    align-items: center;
    min-height: 100vh;
    width: 100%;
    padding: 20px;
    overflow-y: auto;
    overflow-x: hidden;
`